import { render, staticRenderFns } from "./KsLoadingSpinner.vue?vue&type=template&id=9678a8a6&scoped=true"
import script from "./KsLoadingSpinner.vue?vue&type=script&lang=js"
export * from "./KsLoadingSpinner.vue?vue&type=script&lang=js"
import style0 from "./KsLoadingSpinner.vue?vue&type=style&index=0&id=9678a8a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9678a8a6",
  null
  
)

export default component.exports